var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGradientSend = function SvgGradientSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.07 4.425c-.541-.543-1.654-.82-3.443-.223l-8.49 2.83s.001 0 0 0c-1.378.46-2.355.977-2.971 1.486-.62.511-.799.947-.799 1.266 0 .318.18.753.798 1.263.616.508 1.592 1.022 2.972 1.481l2.52.84c.224.075.4.25.475.475l.84 2.52c.459 1.38.973 2.355 1.482 2.971.51.619.946.799 1.266.799.32 0 .755-.18 1.266-.799.509-.616 1.023-1.591 1.482-2.97l2.83-8.49c.592-1.789.315-2.906-.227-3.45Zm1.062-1.06c1.13 1.131 1.258 2.96.59 4.98v.002l-2.83 8.49c-.491 1.475-1.08 2.641-1.75 3.452-.667.81-1.487 1.343-2.422 1.343s-1.755-.534-2.423-1.343c-.67-.81-1.258-1.976-1.748-3.452l-.722-2.164-2.164-.721c-1.475-.491-2.64-1.079-3.452-1.748-.809-.667-1.344-1.485-1.344-2.42 0-.935.535-1.754 1.343-2.422.811-.67 1.977-1.26 3.452-1.753l8.49-2.83c2.021-.674 3.85-.546 4.98.586Z",
    fill: "url(#GradientSend_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.72 9.529a.75.75 0 0 1 .001 1.06l-3.58 3.59a.75.75 0 0 1-1.062-1.059l3.58-3.59a.75.75 0 0 1 1.06-.001Z",
    fill: "url(#GradientSend_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientSend_svg__a",
    x1: 2.867,
    y1: 2.368,
    x2: 22.132,
    y2: 21.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3432C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B632C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientSend_svg__b",
    x1: 9.86,
    y1: 9.31,
    x2: 14.95,
    y2: 14.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3432C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B632C7"
  })))));
};
export default SvgGradientSend;